import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-calendar mr-2" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "予約の詳細", -1)
const _hoisted_3 = { id: "preview-booking-container" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center w-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "p-dialog-title" }, "予約の詳細")
], -1)
const _hoisted_5 = { class: "grid my-2 mx-1 justify-content-center" }
const _hoisted_6 = { id: "booking-page-calendar" }
const _hoisted_7 = { class: "controller-wrapper" }
const _hoisted_8 = {
  key: 0,
  class: "request-booking-infos"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "リクエスト予約", -1)
const _hoisted_10 = { class: "booking-dates" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "booking-item" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "第１希望", -1)
const _hoisted_14 = { class: "date" }
const _hoisted_15 = { class: "col" }
const _hoisted_16 = { class: "booking-item" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "第２希望", -1)
const _hoisted_18 = { class: "date" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "booking-item" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "第３希望", -1)
const _hoisted_22 = { class: "date" }
const _hoisted_23 = { class: "d-flex" }

import { computed, onBeforeMount, ref } from "vue";
/**
 * Vuexストア
 * アプリケーション全体の状態管理に使用
 */
import { useStore } from "vuex";
/**
 * 日付操作ライブラリ
 * 日付のフォーマットや操作に使用
 */
import moment from "moment";
/**
 * カレンダーコンポーネント
 * 予約可能時間の表示に使用
 */
import FullCalendar from "@fullcalendar/vue3";
/**
 * カレンダーのインタラクション機能
 * クリックやドラッグなどの操作に使用
 */
import interactionPlugin from "@fullcalendar/interaction";
/**
 * カレンダーの時間表示機能
 * 時間枠の表示に使用
 */
import timeGridPlugin from "@fullcalendar/timegrid";
/**
 * カレンダーの日本語ロケール
 * 日本語表示に使用
 */
import jaLocale from "@fullcalendar/core/locales/ja";
/**
 * カレンダーのMoment.js連携
 * 日付操作に使用
 */
import momentPlugin from "@fullcalendar/moment";
/**
 * ルーティングユーティリティ
 * 画面遷移の制御に使用
 */
import RouterUtils from "@/common/utils/router.util";
/**
 * ルーティング定数
 * 画面遷移先の定義に使用
 */
import RouterConstants from "../constants/router.constants";
/**
 * 予約ステップのバリデーション
 * 予約フローの制御に使用
 */
import ValidateBookingSteps from "../validates/validate.booking.steps";
/**
 * カレンダー表示の定数
 * 日付フォーマットなどの定義に使用
 */
import { DAY_HEADER_FORMAT, SLOT_LABEL_FORMAT } from "@/customer/typings/constants/booking";
/**
 * VueUseユーティリティ
 * デバウンス処理などに使用
 */
import { AnyFn, get, set, useDebounceFn } from "@vueuse/core";
/**
 * FullCalendarの型定義
 * イベントソースの型定義に使用
 */
import { EventSourceFuncArg } from "@fullcalendar/core";
/**
 * 各種サービス
 * APIリクエストに使用
 */
import { CalendarServices, ClinicServices, RoomServices } from "@/customer/services";
/**
 * カレンダーイベントの型定義
 */
import { ICalendarEvents } from "../typings";
/**
 * 予約プレビューコンポーネント
 * 予約内容の確認表示に使用
 */
import BookingPreview from "@/customer/components/BookingPreview.vue";
/**
 * 予約設定サービス
 * 予約設定の取得に使用
 */
import { BookingSettingService } from "@/customer/services";
/**
 * クリニックパートナーの列挙型
 * パートナー種別の判定に使用
 */
import { ClinicPartner } from "@/clinic/typings/enums/clinic";

/**
 * Vuexストアインスタンス
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'BookingCalendar',
  setup(__props) {

/**
 * 予約カレンダー画面コンポーネント
 * 通常予約とリクエスト予約の両方に対応
 * カレンダー上で予約可能な時間枠を表示し、選択を促す画面
 */

/**
 * Vueの基本機能
 * コンポーネントのライフサイクルとリアクティブな状態管理に使用
 */
const store = useStore();

/**
 * 指名予約モードかどうかを判定する算出プロパティ
 * @type {ComputedRef<boolean>}
 */
const isNominate = computed(() => bookingSetting.value.option === "nominate");

/**
 * FullCalendarのref
 * @type {Ref<InstanceType<typeof FullCalendar> | undefined>}
 */
const calendar = ref();

/**
 * 時間枠の間隔
 * @type {Ref<string>}
 */
const slotDuration = ref("00:30:00");

/**
 * リクエスト予約の選択日時
 * @type {Ref<{first: undefined, second: undefined, third: undefined}>}
 */
const selectedRequestBookings = ref({
  first: undefined,
  second: undefined,
  third: undefined,
});

/**
 * カレンダーイベント一覧
 * @type {Ref<ICalendarEvents[]>}
 */
const events = ref<ICalendarEvents[]>([]);

/**
 * クリニックの電話番号
 * @type {Ref<string>}
 */
const clinicTel = ref("");

/**
 * 予約設定
 * @type {Ref<Record<string, any>>}
 */
const bookingSetting = ref<Record<string, any>>({});

/**
 * 予約詳細の表示属性
 * @type {string[]}
 */
const bookingPreviewAttributes = ["staffName", "orderPrice", "menuName", "menuOptionName", "totalTime", "totalPrice"];

/**
 * 予約詳細モーダルの表示状態
 * @type {Ref<boolean>}
 */
const bookingDetail = ref(false);

/**
 * カレンダーイベントの取得処理
 * デバウンス処理を適用し、APIから予約可能時間を取得
 * @param {EventSourceFuncArg} param0 - カレンダーの表示期間
 * @param {AnyFn} onSuccess - 成功時のコールバック
 * @returns {Promise<any>} カレンダーイベント
 */
const eventsFn = useDebounceFn(async ({ start, end }: EventSourceFuncArg, onSuccess: AnyFn) => {
  // 自動配分スタッフの選択をリセット
  store.commit("booking/selectDistributedStaff", undefined);
  const start_time = moment(start).format("DD-MM-YYYY");
  const end_time = moment(end).format("DD-MM-YYYY");
  // RIPICLE連携時のAPIリクエスト（/open_api/v1/slot_bookings）で使用
  const bookingId = store.getters["booking/bookingId"]; // 0 なら新規予約、1以上なら予約変更
  const params = {
    // bookingId が 0 の場合は {}、それ以外は { booking_id: bookingId } を展開
    ...(bookingId ? { booking_id: bookingId } : {}),
    staff_id: store.getters["booking/selectedStaffId"],
    clinic_id: store.getters["line_account/clinicId"],
    start: start_time,
    end: end_time,
    total_time: store.getters["booking/totalTime"],
    medical_menu_id: store.getters["booking/selectedMenu"].id,
    medical_option_ids: store.getters["booking/selectedOptions"].map(option => option.id),
    distributed_staff_ids: store.getters["booking/autoStaffDistributionData"],
  };
  const { data: calendarEvents } = await CalendarServices.fetchEvents(
    params,
    () => undefined,
    () => undefined
  );
  set(events, get(calendarEvents) as unknown as ICalendarEvents[]);
  // カレンダーの表示時間範囲を設定
  get(calendar)?.getApi().setOption("slotMinTime", get(events)[0]?.slotMinTime);
  get(calendar)?.getApi().setOption("slotMaxTime", get(events)[0]?.slotMaxTime);
  get(calendar)?.getApi()?.render();

  if (!onSuccess) return get(calendarEvents);

  // 選択されたリクエスト予約の日時に応じてイベントのクラスを設定
  get(calendarEvents).forEach(event => {
    Object.values(selectedRequestBookings.value).forEach((booking, index) => {
      if (moment(event.start).unix() == moment(booking).unix()) {
        event.className += ` ${Object.keys(selectedRequestBookings.value)[index]}`;
      }
    });
  });

  return onSuccess(get(calendarEvents));
}, 1000);

/**
 * リクエスト予約メニューかどうか
 * @type {boolean}
 */
const selectedRequestMenu = store.getters["booking/selectedMenu"]?.bookingType == "request";

/**
 * カレンダーのローディング状態変更時の処理
 * @param {boolean} isLoading - ローディング状態
 */
const handleLoadingCalendar = (isLoading: boolean) => {
  if (isLoading == false) {
    setContentHeight();
  }
};

/**
 * カレンダーの高さを設定
 * 表示可能な時間枠に応じて高さを調整
 */
const setContentHeight = () => {
  const timeData = get(calendar)?.getApi()?.currentData?.dynamicOptionOverrides;
  const minTime = moment(timeData.slotMinTime, "HH:mm");
  const maxTime = moment(timeData.slotMaxTime, "HH:mm");
  const duration = moment.duration(timeData.slotDuration);
  // 表示可能な時間枠の総数を計算
  const totalTimes = maxTime.diff(minTime, "minutes") / duration.asMinutes();

  const slotHeight = 45;
  const totalSlotHeight = (totalTimes + 1) * slotHeight;
  // リクエスト予約モードの場合は下部のコントローラー分の高さを調整
  const maxContentHeight = selectedRequestMenu ? window.innerHeight - 420 : window.innerHeight - 320;
  const height = totalSlotHeight > maxContentHeight ? maxContentHeight : totalSlotHeight;
  get(calendar)
    ?.getApi()
    .setOption("contentHeight", height + 3.5 + "px");
};

/**
 * カレンダーの設定オプション
 * @type {Object}
 */
const calendarOptions = {
  plugins: [timeGridPlugin, interactionPlugin, momentPlugin],
  initialView: "timeGridWeek",
  timeZone: "local",
  allDaySlot: false,
  firstDay: moment().format("e"),
  slotLabelFormat: SLOT_LABEL_FORMAT,
  dayHeaderFormat: DAY_HEADER_FORMAT,
  contentHeight: selectedRequestMenu ? "calc(100vh - 420px)" : "calc(100vh - 320px)",
  events: eventsFn,
  eventClick: function (info) {
    handleClickEvent(info);
  },
  headerToolbar: {
    left: "prev",
    center: "title",
    right: "next",
  },
  locale: jaLocale,
  views: {
    timeGrid: {
      titleFormat: "YYYY年MM月",
    },
  },
  loading: function (isLoading: boolean) {
    handleLoadingCalendar(isLoading);
  },
};

/**
 * 戻るボタンクリック時の処理
 * 前の画面に遷移する
 */
const back = () => {
  if (!isNominate.value) {
    RouterUtils.goTo(RouterConstants.BOOKING_OPTION_ROUTER_NAME);
  } else {
    RouterUtils.goTo(RouterConstants.BOOKING_ROUTER_NAME);
  }
};

/**
 * 通常予約の時間選択時の処理
 * @param {any} info - 選択されたイベント情報
 */
const handleClickNormalBooking = async info => {
  store.commit("booking/selectTime", info.event.start);
  store.commit("booking/selectDistributedStaff", info.event.extendedProps.staff_id);
  if (store.getters["bookingSetting/partner"] == ClinicPartner.Unaffiliated) {
    await autoAssignRoom(
      store.getters["booking/selectedMenu"].id,
      moment(info.event.start).format("YYYY-MM-DD HH:mm:ss")
    );
  }
  RouterUtils.goTo(RouterConstants.PERSONAL_INFO_ROUTER_NAME);
};

/**
 * 施術室の自動割り当て
 * @param {any} menuId - メニューID
 * @param {any} startTime - 開始時間
 */
const autoAssignRoom = async (menuId, startTime) => {
  const params = {
    clinic_id: store.getters["line_account/clinicId"],
    menu_id: menuId,
    start_time: startTime,
    booking_type: "normal",
  };
  const { data: roomId } = await RoomServices.assign(
    params,
    () => undefined,
    () => undefined
  );
  store.commit("booking/selectRoom", roomId);
};

/**
 * リクエスト予約の時間選択時の処理
 * @param {any} info - 選択されたイベント情報
 */
const handleClickRequestBooking = info => {
  Object.keys(get(selectedRequestBookings)).some(key => {
    // 既に選択されている日時をクリア
    if (info.el.classList.contains("first")) {
      info.el.classList.remove("first");
      selectedRequestBookings.value["first"] = null;
      return true;
    } else if (info.el.classList.contains("second")) {
      info.el.classList.remove("second");
      selectedRequestBookings.value["second"] = null;
      return true;
    } else if (info.el.classList.contains("third")) {
      info.el.classList.remove("third");
      selectedRequestBookings.value["third"] = null;
      return true;
    } else if (selectedRequestBookings.value[key] == undefined) {
      // 新しい日時を選択
      info.el.classList.add(key);
      selectedRequestBookings.value[key] = info.event.start;
      return true;
    }
  });
};

/**
 * リクエスト予約の送信処理
 * 選択された日時を保存し、施術室を割り当てる
 */
const handleSubmit = async () => {
  store.commit("booking/setRequestDates", get(selectedRequestBookings));
  await autoAssignRooms(store.getters["booking/selectedMenu"].id, get(selectedRequestBookings));
  RouterUtils.goTo(RouterConstants.PERSONAL_INFO_ROUTER_NAME);
};

/**
 * リクエスト予約の施術室自動割り当て
 * @param {any} menuId - メニューID
 * @param {any} requests - リクエスト日時一覧
 */
const autoAssignRooms = async (menuId, requests) => {
  const params = {
    clinic_id: store.getters["line_account/clinicId"],
    menu_id: menuId,
    booking_type: "request",
    requests: requests,
  };
  const { data: roomsData } = await RoomServices.assign(
    params,
    () => undefined,
    () => undefined
  );
  store.commit("booking/setRoomIdForRequests", get(roomsData));
};

/**
 * 送信ボタンの無効化状態
 * リクエスト予約で少なくとも1つの日時が選択されているかどうか
 * @type {ComputedRef<boolean>}
 */
const disableSubmit = computed(() => {
  return Object.values(get(selectedRequestBookings)).filter(value => value !== undefined).length < 1;
});

/**
 * 選択された日時のクリア処理
 * @param {any} key - クリアする日時のキー
 */
const handleClearDate = key => {
  const events = document.querySelectorAll("#booking-page-calendar .fc-event");
  Array.from(events).forEach(event => {
    event.classList.remove(key);
  });
  selectedRequestBookings.value[key] = undefined;
};

/**
 * 予約日時の表示フォーマット
 * @param {any} value - 日時
 * @returns {string} フォーマットされた日時
 */
const showBookingDate = value => {
  return value ? moment(value).format("MM/DD HH:mm") : "-";
};

/**
 * リクエスト予約の日時入れ替え
 * @param {any} firstKey - 入れ替え元のキー
 * @param {any} secondKey - 入れ替え先のキー
 */
const swapDate = (firstKey, secondKey) => {
  [selectedRequestBookings.value[firstKey], selectedRequestBookings.value[secondKey]] = [
    selectedRequestBookings.value[secondKey],
    selectedRequestBookings.value[firstKey],
  ];
  const events = document.querySelectorAll("#booking-page-calendar .fc-event");
  Array.from(events).forEach(event => {
    if (event.classList.contains(firstKey)) {
      event.classList.remove(firstKey);
      event.classList.add(secondKey);
    } else if (event.classList.contains(secondKey)) {
      event.classList.remove(secondKey);
      event.classList.add(firstKey);
    }
  });
};

/**
 * カレンダーイベントクリック時の処理
 * @param {any} info - クリックされたイベント情報
 */
const handleClickEvent = async info => {
  const staffId = info.event.extendedProps.staff_id;
  const isAutoDistribution = store.getters["bookingSetting/autoStaffDistribution"];
  if (isAutoDistribution) {
    // 自動配分の場合、選択されたスタッフを保存
    store.commit("booking/selectDistributedStaff", staffId);
  } else {
    // 指名予約の場合、スタッフIDを保存
    store.commit("booking/setStaffId", staffId);
  }

  const bookingType = store.getters["booking/selectedMenu"]?.bookingType;
  if (info.el.classList.contains("available-booking")) {
    // 予約可能な時間枠の場合
    bookingType == "request" ? handleClickRequestBooking(info) : handleClickNormalBooking(info);
  } else if (info.el.classList.contains("pi-phone")) {
    // 電話予約の場合
    const shopPhoneNumber = get(clinicTel);
    const phoneCallLink = `tel:${shopPhoneNumber}`;
    const phoneCallAnchor = document.createElement("a");
    phoneCallAnchor.href = phoneCallLink;
    phoneCallAnchor.className = "call";
    phoneCallAnchor.click();
  }
};

/**
 * コンポーネントのマウント前の処理
 * 予約設定の読み込みとカレンダーの初期化を行う
 */
onBeforeMount(async () => {
  // 予約フローのバリデーション
  ValidateBookingSteps();
  const settings = store.getters["bookingSetting/bookingDuration"];
  // クリニック情報の取得
  const { data: client } = await ClinicServices.fetchDetails(store.getters["line_account/clinicId"]);
  set(clinicTel, client.value.tel);
  // カレンダーの時間枠設定
  slotDuration.value = moment().startOf("day").add(settings, "minutes").format("HH:mm:00");
  get(calendar)?.getApi().setOption("slotDuration", slotDuration.value);
  get(calendar)?.getApi().setOption("slotLabelInterval", slotDuration.value);
  // 予約設定の読み込み
  const { data: booking_settings } = await BookingSettingService.loadSetting(store.getters["line_account/clinicId"]);
  store.commit("bookingSetting/setBookingSetting", booking_settings.value);
  bookingSetting.value = booking_settings.value;
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      type: "button",
      class: "booking-detail-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (bookingDetail.value = true))
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_Dialog, {
        visible: bookingDetail.value,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((bookingDetail).value = $event)),
        modal: "",
        class: "mx-3 dialog-note controller-wrapper w-100 booking-detail-modal",
        draggable: false,
        appendTo: "self"
      }, {
        header: _withCtx(() => [
          _hoisted_4
        ]),
        default: _withCtx(() => [
          _createVNode(BookingPreview, { previewAttributes: bookingPreviewAttributes }),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              class: "btn preview-booking-detail-btn preview-booking-detail-btn-cancel",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (bookingDetail.value = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode("戻る")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_unref(FullCalendar), {
        options: calendarOptions,
        ref_key: "calendar",
        ref: calendar
      }, null, 512),
      _createElementVNode("div", _hoisted_7, [
        selectedRequestMenu
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_Button, {
                      class: "btn-change btn-change-invisible",
                      icon: "pi pi-arrow-up",
                      "aria-label": "Change",
                      disabled: ""
                    }),
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, _toDisplayString(showBookingDate(selectedRequestBookings.value.first)), 1),
                    _createVNode(_component_Button, {
                      class: "p-button-icon-only",
                      icon: "pi pi-times",
                      "aria-label": "Cancel",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (handleClearDate('first')))
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_Button, {
                      class: "btn-change",
                      icon: "pi pi-arrow-up",
                      "aria-label": "Change",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (swapDate('first', 'second')))
                    }),
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, _toDisplayString(showBookingDate(selectedRequestBookings.value.second)), 1),
                    _createVNode(_component_Button, {
                      class: "p-button-icon-only",
                      icon: "pi pi-times",
                      "aria-label": "Cancel",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (handleClearDate('second')))
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_Button, {
                      class: "btn-change",
                      icon: "pi pi-arrow-up",
                      "aria-label": "Change",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (swapDate('second', 'third')))
                    }),
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, _toDisplayString(showBookingDate(selectedRequestBookings.value.third)), 1),
                    _createVNode(_component_Button, {
                      class: "p-button-icon-only",
                      icon: "pi pi-times",
                      "aria-label": "Cancel",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (handleClearDate('third')))
                    })
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_23, [
          _createVNode(_component_Button, {
            class: "btn cancel-btn",
            onClick: back
          }, {
            default: _withCtx(() => [
              _createTextVNode("選択をやり直す")
            ]),
            _: 1
          }),
          selectedRequestMenu
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "btn accept-btn",
                onClick: handleSubmit,
                disabled: _unref(disableSubmit)
              }, {
                default: _withCtx(() => [
                  _createTextVNode("次に進む")
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ], 64))
}
}

})